import * as React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import LayoutAuth from '../Layouts/Auth';
import SignIn from '../Pages/SignIn';
import AdminSignIn from '../Pages/AdminSignIn';
import { Private } from '../modules/auth/containers';
import RoutesPage from '../Pages/Routes';
import LogoutPage from '../Pages/Logout';
import HubsPage from '../Pages/Hubs';
import FleetsPage from '../Pages/Fleets';
import NewOrderPage from '../Pages/NewOrder';
import OrdersPage from '../Pages/Orders';
import UploadOrders from '../Pages/UploadOrders';
import OrderDetailPage from '../Pages/OrderDetail';
import DriversPage from '../Pages/Drivers';
import SchedulerPage from '../Pages/Scheduler';
import RoutesChart from '../Pages/RoutesChart';
import AdminUsersPage from '../Pages/AdminUsers';
import PartnersPage from '../Pages/Partners';
import PartnerDetailPage from '../Pages/PartnerDetail';
import PartnerDashboard from '../Pages/PartnerDashboard';
import OrderTracking from '../Pages/OrderTracking';

const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

// Component to handle external redirects
const ExternalRedirect = ({ to }) => {
  React.useEffect(() => {
    window.location.href = to;
  }, [to]);

  return <div>Redirecting...</div>;
};

const router = createBrowserRouter([
  {
    path: '/driver-app',
    element: <ExternalRedirect to={process.env.REACT_APP_DRIVER_APP_URL} />,
  },
  {
    path: '/login',
    element: isDemoMode ? (
      <Navigate to="/admin/route-plans" replace />
    ) : (
      <LayoutAuth>
        <SignIn />
      </LayoutAuth>
    ),
  },
  {
    path: '/admin-login',
    element: <AdminSignIn />,
  },
  {
    path: '/logout',
    element: <LogoutPage />,
  },
  {
    path: '/admin/routes',
    element: (
      <Private allowedRoles={['admin']}>
        <RoutesPage />
      </Private>
    ),
  },
  {
    path: '/admin/hubs',
    element: (
      <Private allowedRoles={['admin']}>
        <HubsPage />
      </Private>
    ),
  },
  {
    path: '/admin/fleet',
    element: (
      <Private allowedRoles={['admin']}>
        <FleetsPage />
      </Private>
    ),
  },
  {
    path: '/admin/orders',
    element: (
      <Private allowedRoles={['admin']}>
        <OrdersPage />
      </Private>
    ),
  },
  {
    path: '/admin/orders/new',
    element: (
      <Private allowedRoles={['admin']}>
        <NewOrderPage />
      </Private>
    ),
  },
  {
    path: '/admin/orders/upload',
    element: (
      <Private allowedRoles={['admin']}>
        <UploadOrders />
      </Private>
    ),
  },
  {
    path: '/admin/orders/:id',
    element: (
      <Private allowedRoles={['admin']}>
        <OrderDetailPage />
      </Private>
    ),
  },
  {
    path: '/admin/drivers',
    element: (
      <Private allowedRoles={['admin']}>
        <DriversPage />
      </Private>
    ),
  },
  {
    path: '/admin/scheduler',
    element: (
      <Private allowedRoles={['admin']}>
        <SchedulerPage />
      </Private>
    ),
  },
  {
    path: '/admin/route-plans/:type?',
    element: (
      <Private allowedRoles={['admin']}>
        <RoutesChart />
      </Private>
    ),
  },
  {
    path: '/admin/partners',
    element: (
      <Private allowedRoles={['admin']}>
        <PartnersPage />
      </Private>
    ),
  },
  {
    path: '/admin/partners/:id',
    element: (
      <Private allowedRoles={['admin']}>
        <PartnerDetailPage />
      </Private>
    ),
  },
  {
    path: '/admin/users',
    element: (
      <Private allowedRoles={['superadmin']}>
        <AdminUsersPage />
      </Private>
    ),
  },
  {
    path: '/partner/orders',
    element: (
      <Private allowedRoles={['partner_viewer']}>
        <PartnerDashboard />
      </Private>
    ),
  },
  {
    path: '/partner/orders/:id',
    element: (
      <Private allowedRoles={['partner_viewer']}>
        <OrderDetailPage />
      </Private>
    ),
  },
  {
    path: '/t/:orderCode/:token',
    element: <OrderTracking />,
  },
  {
    path: '/*',
    element: <Navigate to="admin/route-plans" replace />,
  },
]);

export default router;
